import React, { Component } from 'react';
import NavigationTabs from '../../components/NavigationTabs/PromoterNavigationTabs';
import NewLoader from '../../components/NewLoader/NewLoader';
import ROUTES from '../../constants/routes';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';

import EmailTemplates from './PromoterPages/EmailTemplates/EmailTemplates';
import PromoterInfo from './PromoterPages/Info/PromoterInfo';
import IframesList from './PromoterPages/IframesPage/IframesList';
import Iframe from './PromoterPages/IframesPage/Iframe';
import BalancePage from './PromoterPages/BalancePage/BalancePage';
import PromoterStatistics from './PromoterPages/PromoterStatistics/PromoterStatistics';
import PromoterThemesPage from './PromoterPages/ThemesPage/ThemesPage';
import PromoterMailbox from './PromoterPages/PromoterMailbox/PromoterMailbox';
import { PaymentMethodsPage } from './PromoterPages/PaymentMethodsPage/PaymentMethodsPage';

import './Promoter.sass';
import browserTabTitleOverride from '../../helpers/tabTitleOverride';

class Promoter extends Component {
  componentDidMount() {
    browserTabTitleOverride('Promoter');
  };

  componentDidUpdate(prevProps) {
    if (this.props.match.path !== prevProps.match.path) {
      browserTabTitleOverride('Promoter');
    }
  }

  render() {
    return (
      <section className='promoter'>
        <div className='promoter__wrapper'>
          <div className='promoter__nav'>
            <NavigationTabs />
          </div>

          <div className='promoter__container'>
            {this.props.loading && (
              <div className='promoter__loader'>
                <NewLoader />
              </div>
            )}

            <Switch>
              <Redirect
                from={ROUTES.PROMOTER}
                to={ROUTES.PROMOTER_INFO}
                exact
              />

              <Route
                path={ROUTES.PROMOTER_INFO}
                exact
                component={PromoterInfo}
              />
              <Route
                path={ROUTES.PROMOTER_TEMPLATES}
                exact
                component={EmailTemplates}
              />
              <Route
                path={ROUTES.PROMOTER_IFRAMES}
                exact
                component={IframesList}
              />
              <Route path={ROUTES.PROMOTER_IFRAME} exact component={Iframe} />
              <Route path={ROUTES.PROMOTER_THEMES} exact component={PromoterThemesPage} />
              <Route path={ROUTES.PROMOTER_PAYMENT_METHODS} exact component={PaymentMethodsPage} />
              <Route
                path={ROUTES.PROMOTER_STATISTICS}
                exact
                component={PromoterStatistics}
              />
              <Route
                path={ROUTES.PROMOTER_BALANCE}
                exact
                component={BalancePage}
              />
              <Route
                path={ROUTES.PROMOTER_EMAIL}
                exact
                component={PromoterMailbox}
              />
            </Switch>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({
  auth: { user },
  events: { currentEvent, loading, error, currentTicket },
}) => ({ user, currentEvent, loading, error, currentTicket });

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Promoter));
